export default function loadingDataSelector(func) {
  let { loadingReducer } = func((state) => state);
  return loadingReducer;
}
